<div class="articles-container">
    <div class="careers-poasted-jobs">
        <h1>Search for your next job</h1>
        <div class="align-h h-space-large">
            <!-- Search by title, skill or position -->
            <div class="form-group stretch">
                <mat-form-field class="width-responsive-mobile">
                    <input
                        type="text"
                        matInput
                        placeholder="Search by title, skill or position"
                        [(ngModel)]="searchText"
                        name="jobSearch"
                        #jobSearch="ngModel"
                        (keypress)="keyPress($event)"
                    >
                </mat-form-field>
            </div>
            <!-- Select department -->
            <div class="form-group stretch">
                <mat-form-field class="width-responsive-mobile">
                    <mat-select
                        disableOptionCentering
                        placeholder="Select department"
                        [(ngModel)]="jobData.department"
                        name="department"
                        #department="ngModel"
                    >
                        <mat-option
                            *ngFor="let department of departmentList"
                            [value]="department.id"
                        >
                            {{ department.value }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- Select job location -->
            <div class="form-group stretch">
                <mat-form-field class="width-responsive-mobile">
                    <mat-select
                        disableOptionCentering
                        placeholder="Select job location"
                        [(ngModel)]="jobData.location"
                        name="joblocation"
                        #joblocation="ngModel"

                    >
                        <mat-option
                            *ngFor="let location of locationList"
                            [value]="location.id"
                        >
                            {{ location.value }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- BUTTON -->
            <button
                mat-raised-button
                color="primary"
                class="mat-button-medium margin-bottom-25"
                type="button"
                (click)="searchJob()"
            >
                Search
            </button>
        </div>
        <div class="careers-posted-job-result">
            <ng-template [ngIf]="postedJobList?.length === 0">
                <p class="careers-result-p">
                    There are no openings currently available in this role. Please check back later.
                </p>
            </ng-template>
            <ng-template [ngIf]="postedJobList?.length > 0">
                <mat-accordion *ngFor="let job of postedJobList">
                    <mat-expansion-panel
                        *ngIf="job?.isActive"
                        class="margin-bottom-20"
                        (opened)="panelMap[job?.id] = true"
                        (closed)="panelMap[job?.id] = false"
                        
                    >
                        <mat-expansion-panel-header class="mat-expansion-panel-header--auto">
                            <div class="list-item width-stretch">
                                <div class="list-item-content">
                                    <div class="margin-bottom-10">
                                        <h4>{{ job?.jobPostion }}</h4>
                                    </div>
                                    <p>{{ job?.location }}</p>
                                    <p>{{ job?.department }}</p>
                                </div>
                                <div class="list-item-action">
                                    <button
                                        mat-raised-button
                                        color="primary"
                                        class="mat-button-medium margin-right-20"
                                        (click)="openApplyJobDialog()"
                                    >
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </mat-expansion-panel-header>
                        <p
                            class="font-20"
                            [innerHTML]=[job?.description]
                        ></p>
                        <p class="font-20 margin-top-35">Share this on</p>
                        <p>
                            <a
                                href="https://www.facebook.com/sharer/sharer.php?u={{ pageUrl }}"
                                target="_blank"
                            >
                                <img
                                    src="assets/svg/Facebook.svg"
                                    alt="facebook"
                                >
                            </a>
                            <a
                                href="https://twitter.com/share?url={{ pageUrl }}"
                                target="_blank"
                            >
                                <img
                                    class="margin-left-15"
                                    src="assets/svg/Twitter.svg"
                                    alt="twitter"
                                >
                            </a>
                            <a
                                href="https://www.linkedin.com/shareArticle?url={{ pageUrl }}"
                                target="_blank"
                            >
                                <img
                                    class="margin-left-15"
                                    src="assets/svg/LinkedIN.svg"
                                    alt="linkedin"
                                >
                            </a>
                        </p>
                    </mat-expansion-panel>
                </mat-accordion>
            </ng-template>
            <p class="careers-result-p margin-top-30">
                You can apply by clicking on a current opening or send us your updated resumes to
                <span>careers@itiorg.com</span>
            </p>
        </div>
    </div>
    <app-life-at-iti></app-life-at-iti>
</div>
